<template>
  <modal
    content-class="system-communications-email-config-modal"
    :title="$t('message.email.message.emailSettings')"
    :value="showing"
    :closeable="true"
    @input="emitShowing"
  >
    <app-form @submit="emitUpdateConfig">
      <stepper-section :label="$t('message.marketingGenerics.message.content')">
        <text-field
          class="system-communications-email-config-modal-text"
          v-model="form.subject"
          :label="$t('message.email.message.subject')"
          name="Assunto"
          :help="$t('message.email.message.tooltipEmailSubject')"
          :text="`${this.$t('message.email.message.subjectLength1')} ${
            form.subject ? form.subject.length : 0
          } ${this.$t('message.email.message.subjectLength2')}`"
          validate="required|max:60"
        />
        <button-toggle
          v-if="loaded"
          :label="{
            opened: this.$t('message.generics.message.advancedSettings'),
            closed: this.$t('message.generics.message.advancedSettings'),
          }"
          :start-opened="!!form.brief"
        >
          <text-field
            class="system-communications-email-config-modal-text"
            v-model="form.brief"
            :label="this.$t('message.email.message.textPreview')"
            name="Prévia do texto"
            :help="this.$t('message.email.message.tooltipTextPreview')"
          />
        </button-toggle>
      </stepper-section>

      <stepper-section :label="this.$t('message.email.message.senderData')">
        <text-field
          class="system-communications-email-config-modal-text"
          v-model="form.senderName"
          :label="this.$t('message.email.message.senderName')"
          name="Nome do remetente"
          :help="this.$t('message.email.message.tooltipSenderName')"
          validate="required"
        />

        <text-field
          class="system-communications-email-config-modal-text"
          v-model="form.senderEmail"
          :label="this.$t('message.email.message.senderEmail')"
          name="E-mail do remetente"
          :help="this.$t('message.email.message.tooltipSenderEmail')"
          :text="this.$t('message.email.message.validEmailWarning')"
          validate="required"
        />
      </stepper-section>

      <div class="system-communications-email-config-modal-actions">
        <button class="btn btn-round btn-primary" type="submit">
          {{ $t("message.generics.message.save") }}
        </button>
      </div>
    </app-form>
  </modal>
</template>

<script>
import ButtonToggle from "@/components/generic/button/toggle/ButtonToggle";
import StepperSection from "@components/StepperSection";
import TextField from "@components/form/TextField.vue";
import AppForm from "@components/form/Form.vue";
import Modal from "@components/generic/Modal.vue";

export default {
  components: {
    Modal,
    AppForm,
    TextField,
    StepperSection,
    ButtonToggle,
  },

  props: {
    showing: {
      type: Boolean,
      default: false,
    },
    closeable: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      required: false,
    },
  },

  watch: {
    showing(value) {
      if (value) {
        this.setInitialData();
      }
    },
  },

  data() {
    return {
      form: {
        senderEmail: undefined,
        senderName: undefined,
        brief: undefined,
        subject: undefined,
      },
      loaded: false,
    };
  },

  methods: {
    emitShowing(showing) {
      this.$emit("update:showing", showing);
    },

    emitUpdateConfig() {
      this.$emit("update-config", this.form);
    },
    setInitialData() {
      if (this.config) {
        this.form.senderName = this.config.senderName;
        this.form.senderEmail = this.config.senderEmail;
        this.form.subject = this.config.subject;
        this.form.brief = this.config.brief;
      }
    },
  },

  computed: {},

  mixins: [],

  mounted() {
    this.setInitialData();
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
.system-communications-email-config-modal {
  .system-communications-email-config-modal-text {
    margin-bottom: 0;
    padding-top: 15px;
  }

  .system-communications-email-config-modal-actions {
    display: flex;
    justify-content: center;
    gap: 25px;
  }
}
</style>
